export function slugifySeriesName(value: string | null | undefined) {
  let cleaned = (value || "Uncategorized").trim();
  // Strip season suffixes like " - 2026 Season 2", " - 2025 Season"
  // to match backend normalize_series_name behavior. A following "Fixed"/"Open" is kept.
  cleaned = cleaned.replace(/\s*-\s*\d{4}\s+season(?:\s+\d+)?\s*$/i, "");
  // #529: a season token anywhere ("Series - 2026 Season 2 - Fixed", "Series 2026
  // Season 3", "Car 2026 - Season 3"). Identical to backend normalize_series_name;
  // pinned by seriesSlugs.test.ts against a fixture generated from the backend.
  cleaned = cleaned.replace(/\s*-?\s*\b\d{4}\s*-?\s*season\b(?:\s+\d+)?/gi, "");
  cleaned = cleaned.replace(/\s*-\s*(?:-\s*)+/g, " - ").replace(/\s{2,}/g, " ").replace(/^[\s-]+|[\s-]+$/g, "");
  const slug = cleaned.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return slug || "uncategorized";
}
